export const StorageKey = {
    TOKEN: 'token',
    USER: 'user'
};

export const DefaultSwrOptions = {
    revalidateOnFocus: false,
    revalidateOnReconnect: false,
}
export const Role = {
    admin: { name: 'Admin', value: 'admin' },
    employee: { name: 'Employee', value: 'employee' }
}

export const LeaveStatus = {
    pending: { name: 'Pending', value: 'pending' },
    approved: { name: 'Approved', value: 'approved' },
}

export const ExpenseStatus = {
    pending: { name: 'Pending', value: 'pending' },
    completed: { name: 'Completed', value: 'completed' },
}